import Cookies from "js-cookie";
import { useResponsive } from "../hooks/useResponsive";
import { useAppSelector } from "../services/store";
import SidebarRow from "./SidebarRow";
import { useState } from "react";

interface SidebarProps {
  className?: string;
}

export const Sidebar = ({ className = "" }: SidebarProps) => {
  const userReducer = useAppSelector((state) => state.userReducer);
  const { isMobile, isTablet } = useResponsive();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const logout = () => {
    if (isMobile) {
      const ok = confirm("آیا می‌خواهید از حساب کاربری خود خارج شوید؟");
      if (!ok) return;
    }
    Cookies.remove("token");
    window.location.reload();
  };

  const closeSidebar = () => {
    if (isMobile) setSidebarOpen(false);
  };

  return (
    <>
      {(isMobile || isTablet) && (
        <button
          className="mobile-menu-toggle"
          onClick={() => setSidebarOpen(!sidebarOpen)}
          aria-label="منوی کناری"
          aria-expanded={sidebarOpen}
        >
          ☰
        </button>
      )}

      {(isMobile || isTablet) && sidebarOpen && (
        <div
          className="sidebar-backdrop show"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <aside
        className={`sideBarContainer ${sidebarOpen ? "mobile-open" : ""} ${className}`}
      >
        {/* Menu panel */}
        <div className="adminInfoContainer">
          {/* User info */}
          <div className="admininfo">
            <i className="adminSvg" />
            <div className="adminNameSection">
              <h6 className="adminName">
                {userReducer?.profile?.name || "مدیر"}
              </h6>
              <p className="adminTitle">ادمین</p>
            </div>
          </div>
          <SidebarRow
            title="داشبورد"
            url="/dashboard"
            onClick={closeSidebar}
            icon={
              <i className="chartSvg activSvg" role="img" title="داشبورد" />
            }
          />
          <SidebarRow
            title="سفارشات"
            url="/order/"
            onClick={closeSidebar}
            icon={
              <i className="basketSvg activSvg" role="img" title="سبد خرید" />
            }
          />
          <SidebarRow
            title="کاربران"
            url="/User"
            onClick={closeSidebar}
            icon={
              <i className="usersSvg activSvg" role="img" title="کاربران" />
            }
          />
          <SidebarRow
            title="محصولات"
            url="/Product"
            onClick={closeSidebar}
            icon={
              <i className="packingSvg activSvg" role="img" title="محصولات" />
            }
          />
          <SidebarRow
            title="تغییر گروهی"
            url="/product/bulk"
            onClick={closeSidebar}
            icon={
              <i className="packingSvg activSvg" role="img" title="تغییر گروهی" />
            }
          />
          <SidebarRow
            title="تگ"
            url="/tag"
            onClick={closeSidebar}
            icon={<i className="tagSvg activSvg" role="img" title="محصولات" />}
          />
          <SidebarRow
            title="منو"
            url="/menu"
            onClick={closeSidebar}
            icon={<i className="menuSvg activSvg" role="img" title="محصولات" />}
          />
          {/*<SidebarRow
            title="ماشین"
            url="/car"
            onClick={closeSidebar}
            icon={<i className="carSvg activSvg" role="img" title="محصولات" />}
          />*/}
          <SidebarRow
            title="سال"
            url="/year"
            onClick={closeSidebar}
            icon={<i className="yearSvg activSvg" role="img" title="محصولات" />}
          />
          <SidebarRow
            title="برند"
            url="/brand"
            onClick={closeSidebar}
            icon={
              <i className="brandSvg activSvg" role="img" title="محصولات" />
            }
          />
          <SidebarRow
            title="روش ارسال"
            url="/deliveryMethod"
            onClick={closeSidebar}
            icon={
              <i
                className="deliveryMethodSvg activSvg"
                role="img"
                title="محصولات"
              />
            }
          />
          <SidebarRow
            title="روش پرداخت"
            url="/paymentMethod"
            onClick={closeSidebar}
            icon={
              <i
                className="paymentMethodSvg activSvg"
                role="img"
                title="محصولات"
              />
            }
          />
          <SidebarRow
            title="صفحات"
            url="/page"
            onClick={closeSidebar}
            icon={<i className="pageSvg activSvg" role="img" title="محصولات" />}
          />
          <SidebarRow
            title="رنگ ها"
            url="/color"
            onClick={closeSidebar}
            icon={
              <i className="colorSvg activSvg" role="img" title="محصولات" />
            }
          />
          <SidebarRow
            title="نوع کالا"
            url="/part"
            onClick={closeSidebar}
            icon={<i className="partSvg activSvg" role="img" title="محصولات" />}
          />
          {/*<SidebarRow
            title=""
            url="/attributeValue"
            onClick={closeSidebar}
            icon={
              <i className="productSvg activSvg" role="img" title="محصولات" />
            }
          />*/}
          <SidebarRow
            title="دسته بندی"
            url="/category"
            onClick={closeSidebar}
            icon={
              <i className="categorySvg activSvg" role="img" title="محصولات" />
            }
          />
          {/*<SidebarRow
            title="واریانت"
            url="/variant"
            onClick={closeSidebar}
            icon={
              <i className="variantSvg activSvg" role="img" title="محصولات" />
            }
          />*/}
          <SidebarRow
            title="بسته بندی"
            url="/packing"
            onClick={closeSidebar}
            icon={
              <i className="packingSvg activSvg" role="img" title="محصولات" />
            }
          />
          <SidebarRow
            title="گارانتی"
            url="/guaranteeCompany"
            onClick={closeSidebar}
            icon={
              <i className="productSvg activSvg" role="img" title="گارانتی" />
            }
          />
          <SidebarRow
            title="مشخصات فنی"
            url="/specific"
            onClick={closeSidebar}
            icon={
              <i className="productSvg activSvg" role="img" title="محصولات" />
            }
          />
          <SidebarRow
            title="لندینگ"
            url="/landing"
            onClick={closeSidebar}
            icon={
              <i className="landingSvg activSvg" role="img" title="محصولات" />
            }
          />
          <SidebarRow
            title="لندینگ ماشین"
            url="/carLanding"
            onClick={closeSidebar}
            icon={
              <i
                className="carLandingSvg activSvg"
                role="img"
                title="محصولات"
              />
            }
          />
          <SidebarRow
            title="تخفیف"
            url="/discount"
            onClick={closeSidebar}
            icon={
              <i className="discountSvg activSvg" role="img" title="محصولات" />
            }
          />
          <SidebarRow
            title="تنظیمات عمومی"
            url="/setting"
            onClick={closeSidebar}
            icon={
              <i className="infoSvg activSvg" role="img" title="تنظیمات عمومی" />
            }
          />
        </div>

        {/* Icon strip */}
        <div className="sideBar">
          {/*<div className="pic" title="یدکیار" />*/}

          {/*<i className="categorySvg activSvg" role="img" title="دسته‌بندی‌ها" />
          <i className="menuSvg activSvg" role="img" title="منو" />*/}
          <i
            className="sidBarExit activSvg clickable"
            onClick={logout}
            role="button"
            tabIndex={0}
            title="خروج"
            onKeyDown={(e) => e.key === "Enter" && logout()}
          />
        </div>
      </aside>
    </>
  );
};
